// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".template-list[data-v-0d79da83]{grid-gap:8px;display:grid;gap:8px;grid-template-columns:repeat(2,1fr)}@media only screen and (min-width:600px){.template-list[data-v-0d79da83]{grid-template-columns:repeat(4,1fr)}}.template-list__item[data-v-0d79da83]{position:relative}.template-list__checkbox[data-v-0d79da83]{position:absolute;right:8px;top:8px;z-index:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
